import V from 'voUtils/V.js';

export default {
	props: {
		carouselId: String
	},

	mounted: function () {
		$("#owl-" + 'startblog').owlCarousel({
			items: 2,
			loop: true,
			autoplay: false,
			dots: true,
			smartSpeed: 1000,
			nav: false,
			autoplayTimeout: 10000,
			margin: VOFFICE.settings.olwCarouselMargin,
			responsive: {

				0: {
					items: 1
				},

				768: {
					items: 2
				},
				992: {
					items: 3
				}
			}
		});
	}
};